import { FilterByCallback } from "react-bootstrap-typeahead/types/types";
import { isString } from "@civicscience/chops";
import { typeaheadFilterByContainsAll } from "utils";

const typeaheadFilterByLabelKeyContainsAll: FilterByCallback = (option, typeaheadProps) => {
  const optionRecord = option as unknown as Record<string, string>;
  const { labelKey } = typeaheadProps;
  const label = isString(labelKey) ? optionRecord[labelKey] : labelKey(option);
  return typeaheadFilterByContainsAll(label, option, typeaheadProps);
};

export default typeaheadFilterByLabelKeyContainsAll;
